import { TournamentTypes } from 'common';

import { InjectableHook } from 'domain/hooks';

export const TournamentsRepository = Symbol('TournamentsRepository');

export type ITournamentsRepository = InjectableHook<{
  fetchTournaments(locationId?: string): Promise<TournamentTypes.TournamentConfig[]>;
}>;
